import { isNumber } from "./isNumber";

export const returnNumberOrValue = (
  value: number | string | null,
  returnedValue: any
) => (isNumber(value) || value ? Number(value) : returnedValue);
